import { api, ApiResponse } from './api';
import { User } from '@/models/user.model';

export const authService = {
  // Login user
  login: (credentials: {
    email: string;
    password: string;
  }): Promise<ApiResponse<{ user: User; token: string; refreshToken: string }>> => {
    // For demo purposes, simulate API call
    return api.post<ApiResponse<{ user: User; token: string; refreshToken: string }>>(
      '/clinic/login',
      credentials
    );
  },

  // Logout user
  logout: (): Promise<void> => {
    // For demo purposes, simulate API call
    return api.post<void>('/clinic/logout');
  },

  // Get current user
  getCurrentUser: (): Promise<ApiResponse<{ user: User; token: string; refreshToken: string }>> => {
    return api.get<ApiResponse<{ user: User; token: string; refreshToken: string }>>('/clinic/me');
  },

  // Forgot password email trigger
  forgotPassword: (email: string): Promise<ApiResponse<void>> => {
    return api.post<ApiResponse<void>>('/clinic/forgot-password', { email });
  },

  resetPassword: (token: string, password: string): Promise<ApiResponse<void>> => {
    return api.post<ApiResponse<void>>(`/clinic/reset-password/${token}`, { password });
  },

  verifyInvite: (token: string): Promise<ApiResponse<void>> => {
    return api.get<ApiResponse<void>>(`/clinic/check-invitation/${token}`);
  },

  acceptInvitation: (
    token: string,
    password: string,
    role?: string,
    clinicId?: string
  ): Promise<ApiResponse<void>> => {
    return api.post<ApiResponse<void>>(`/clinic/accept-invitation/${token}`, {
      password,
      role,
      clinicId,
    });
  },

  // Change password
  changePassword: (currentPassword: string, newPassword: string): Promise<ApiResponse<void>> => {
    return api.put<ApiResponse<void>>('/clinic/change-password', {
      currentPassword,
      newPassword,
    });
  },

  // Get practitioner clinics
  getPractitionerClinics: (): Promise<ApiResponse<{ clinics: any[] }>> => {
    return api.get<ApiResponse<{ clinics: any[] }>>('/practitioners/clinics');
  },

  // Select clinic for practitioner
  selectClinic: (clinicId: string): Promise<ApiResponse<{ user: User }>> => {
    return api.post<ApiResponse<{ user: User }>>('/clinic/select-clinic', { clinicId });
  },
};
